<template>
  <nav class="breadcrumb-container" aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li
        v-for="(item,index) in bread_crumb_data"
        :key="index"
        class="breadcrumb-item"
      >
        <span :class="{'text-primary': !item.isActive}">{{ item.name }}</span>
      </li>


    </ol>

    <div v-if="this.$slots.suffix" class="suffix">
      <slot name="suffix"></slot>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'BreadCrumb',
  props: {
    bread_crumb_data: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scope>
.breadcrumb-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #e9ecef;
  padding-right: 1rem;
  border-radius: 0.25rem;
  margin-bottom: 20px;
  .breadcrumb {
    margin: 0;
    background-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/BreadCrumb.vue